<template>
  <q-page padding>   
    <q-card> 
    <q-card-title>
      <div class="col">
        <div class="text-h6">{{$t('global.ExcelAnalytics')}}</div> 
      </div>
    </q-card-title>
    <q-card-separator />
    <div class="row">
      <div class="col q-pa-md">
          <q-select v-model="IdReport" :options="excelReportList"  :float-label="$t('global.ExcelReports')" />
      </div>
    </div>
    <div class="row">
      <div class="col q-pa-md">
          <q-datetime v-model="pDateFrom" type="date" :float-label="$t('global.DateFrom')" format="DD.MMM.YYYY"/>
      </div>
      <div class="col q-pa-md">
        <q-datetime v-model="pDateTo" type="date" :float-label="$t('global.DateTo')" format="DD.MMM.YYYY"/>
      </div>
      </div>
      <div class="row">
        <div class="col q-pa-md">
          <q-btn :disable="!IdReport" :label="$t('global.DownloadExcel')" color="primary" @click="run"/>
        </div>
        <div class="col q-pa-md">
          <q-btn v-if="IdReport" :disable="!IdReport" :label="$t('global.DeleteExcelTemplate')" color="primary" @click="deleteExcel" outline/>
        </div>
      </div>
    
    </q-card>  
    <q-card class="secondCard">
    
    <q-card-title>
      <div class="col">
        <div class="text-h6">{{$t('global.UploadExcelTemplate')}}</div>
      </div>
    </q-card-title>
    <q-card-separator />

    <div class="row">
        <div class="col q-pa-md">
          <q-input v-model="reportName" :float-label="$t('global.NewExcelReportName')"></q-input>
        </div>
      <div class="col q-pa-md">
        <q-select
          v-model="selectType"
          float-label="Type"     
          :options="selectTypeOptions"
          label="Report Type"
          emit-value map-options
        />
      </div>
    </div>
      <div class="row">
        <div class="col q-pa-md">
        <q-uploader
          :url="uploadUrl"
          :label="$t('global.UploadExcelTemplate')"
          color="secondary"
         
          style="max-width: 300px"  
          :additional-fields="formfields"
          extensions=".xlsx"
          @added="setUpload"
          @finish="uploaded"
          :disable="!reportName || !selectType"
        />
        </div>
      </div>
    </q-card>
  </q-page>
</template>
<script>
import axios from 'axios'
import qs from 'qs'
export default {
  data () {
    return {
      reportName: '',
      uploadUrl: this.$apiGoUrl + "/upload/",
      form: {},   
      IdReport: null,
      selected: [],
      pDateFrom: this.moment().add(-100, 'days').toISOString(),
      pDateTo: this.moment().toISOString(),
      optionReport: [],  
      formfields: [],
      selectType: 1, 
      selectTypeOptions: [
        {
          label: this.$t('global.Yield') ,
          value: 1, 
        },
        {
          label: this.$t('global.WorkJournal') ,
          value: 2, 
        },
        {
          label: 'Geo Kosten' ,
          value: 3, 
        },
        {
          label: 'Produkte Kosten' ,
          value: 4, 
        }
      ],
      excelReportList: [],

    }
  },
  methods: {
    dateFormat(val) {
      if(val == null){
        return null
      }
      return this.moment(val).format(this.$store.state.session.DateFormat)
    },
    run(){
      this.form = {}
      if (this.$q.platform.is.ios){
        var windowReference = window.open()
      }
      this.form.SessionId = this.$store.state.session.SessionId
      this.form.DateFrom = this.pDateFrom
      this.form.DateTo = this.pDateTo
      this.form.IdReport = this.IdReport
      axios.post(this.$apiGoUrl + "/excel/",
      qs.stringify(this.form),
      {
          responseType: 'blob', 
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      })
      .then((response) => {
          const url = URL.createObjectURL(new Blob([response.data], {
              type: 'application/vnd.ms-excel'
          }))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', "Excel.xlsx")
          document.body.appendChild(link)
          link.click()
      })
      .catch(e => {
        this.loading = false
        this.$q.notify('Something Wrong.')
        console.log(e);
      })
    },
    deleteExcel(){ 
      this.$q.dialog({
        title: this.$t('global.DeleteExcelTemplate'),
        message: this.$t('global.DeleteExcelTemplateQuestion'),
        cancel: true
      }).then(() => {
        this.form.SessionId = this.$store.state.session.SessionId
        this.form.action = "DeleteExelReports"
        this.form.IdReport = this.IdReport
        axios.post(this.$apiGoUrl + "/excelreport/",
        qs.stringify(this.form),
        {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        })
        .then((response) => {
            if(response.status == 200){ 
              this.loadReportList()
              this.IdReport = null 
              this.$q.notify({ message: this.$t('global.ExcelTemplateDeleted'), type: 'positive'})
            }
        })
        .catch(e => {
          this.loading = false
          this.$q.notify('Something Wrong.')
          console.log(e);
        })
      }).catch(() => {
        // console.log('Cancel')
      }).onDismiss(() => {
        // console.log('I am triggered on both OK and Cancel')
      })
    },
    setUpload(){
      this.formfields = []
      this.formfields.push({name: 'SessionId', value: this.$store.state.session.SessionId})
      this.formfields.push({name: 'ReportName', value: this.reportName})
      this.formfields.push({name: 'Type', value: this.selectType})
    },
    uploaded(){
      this.$q.notify({ message: this.$t('global.UploadOk'), type: 'positive'})
      this.loadReportList()
    },
    loadReportList(){
      this.form.SessionId = this.$store.state.session.SessionId
      this.form.action = "GetExelReports"
      axios.post(this.$apiGoUrl + "/excelreport/",
      qs.stringify(this.form),
      {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      })
      .then((response) => {
          if(response.status == 200){ 
            this.excelReportList = []
            response.data.forEach(rep => { 
              this.excelReportList.push({value: rep.ExcelReportID, label: rep.ReportName})
            })
          }
      })
      .catch(e => {
        this.loading = false
        this.$q.notify('Something Wrong.')
        console.log(e);
      })
    }
  },
  watch: {
    reportName: function (newValue, oldValue) {
      this.setUpload()
    },
    selectType: function (newValue, oldValue) {
      this.setUpload()
    }
   },

   mounted () {
    this.loadReportList()
   },
}
</script>
<style scoped>
.secondCard{
  margin-top: 20px;
}

</style>
